// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1B0xt","productName":"Table_productName__2Tqxr"};